import { buildWhatsAppUrl } from '../../../core/contact/whatsappLink.js';
import { esCuentaPremiumPerfil } from '../../../core/monetizacion/planes.js';
import { runTarjetaDeckOpenTransition, prefersReducedMotionTarjeta } from '../../../core/ui/tarjetaDeckTransition.js';
import { openMiniModalOk } from '../../../core/ui/miniModal.js';
import { withBusyButton } from '../../../core/ui/withBusyButton.js';
import { escapeHtml as esc } from '../../../core/ui/escapeHtml.js';
import { initialsFromNameEmail } from '../../../core/ui/initials.js';
import {
  DIAS_SEMANA_ORDEN,
  diaSemanaMLVDesdeDate,
  estadoVacioSemana,
  listaOpcionesMediaHora,
  perfilTieneDisponibilidadEnDia,
  slotsDesdePerfil,
  textoDisponibilidadParaPublico,
} from '../domain/serviciosDisponibilidad.js';
import { CATEGORIAS_SERVICIOS, labelRubroServicio } from '../domain/serviciosRubros.js';
import { normalizarRubrosPerfil, validarPayloadMiPerfilServicios } from '../domain/serviciosProfileRules.js';
import { mlvPng } from '../../../core/ui/mlvPngIcons.js';

const OPTS_HORAS_MEDIA = listaOpcionesMediaHora();

function htmlOptsHora(selected) {
  return OPTS_HORAS_MEDIA.map(
    (h) => `<option value="${esc(h)}"${h === selected ? ' selected' : ''}>${esc(h)}</option>`
  ).join('');
}

function htmlTramoHorario(desde, hasta) {
  return `<div class="serv-tramo flex flex-wrap items-center gap-2">
    <select class="serv-desde rounded-lg border border-slate-200 bg-white py-2 px-2 text-xs text-slate-900">${htmlOptsHora(desde)}</select>
    <span class="text-xs text-slate-500">a</span>
    <select class="serv-hasta rounded-lg border border-slate-200 bg-white py-2 px-2 text-xs text-slate-900">${htmlOptsHora(hasta)}</select>
  </div>`;
}

function htmlBloqueDisponibilidadSemana(prof) {
  const est = slotsDesdePerfil(prof);
  const defA = '09:00';
  const defB = '18:00';
  return DIAS_SEMANA_ORDEN.map(({ id, label }) => {
    const tramos = est[id] || [];
    const on = tramos.length > 0;
    const mostrar = on ? tramos.slice(0, 2) : [{ desde: defA, hasta: defB }];
    const tramosHtml = mostrar.map((t) => htmlTramoHorario(t.desde, t.hasta)).join('');
    return `<div data-serv-dia="${id}" class="rounded-xl border border-slate-100 bg-slate-50/80 px-3 py-2">
      <label class="flex cursor-pointer items-center gap-2 text-sm font-medium text-slate-800">
        <input type="checkbox" class="serv-dia-on h-4 w-4 rounded border-slate-300 accent-brand-primary"${on ? ' checked' : ''} />
        <span>${esc(label)}</span>
      </label>
      <div class="serv-dia-tramos mt-2 space-y-2 pl-6${on ? '' : ' hidden'}">${tramosHtml}</div>
      <button type="button" class="serv-add-tramo mt-2 pl-6 text-left text-xs font-semibold text-brand-primary hover:underline${on ? '' : ' hidden'}">+ Otro horario</button>
    </div>`;
  }).join('');
}

function readDisponibilidadSemanaEstadoFromDom() {
  const estado = estadoVacioSemana();
  document.querySelectorAll('[data-serv-dia]').forEach((row) => {
    const dia = Number(row.getAttribute('data-serv-dia'));
    if (Number.isNaN(dia)) return;
    if (!row.querySelector('.serv-dia-on')?.checked) return;
    row.querySelectorAll('.serv-tramo').forEach((tr) => {
      const a = tr.querySelector('.serv-desde')?.value || '';
      const b = tr.querySelector('.serv-hasta')?.value || '';
      if (!a || !b) return;
      if (!estado[dia]) estado[dia] = [];
      if (estado[dia].length < 2) estado[dia].push({ desde: a, hasta: b });
    });
  });
  return estado;
}

function wireDisponibilidadSemanaUi() {
  document.querySelectorAll('.serv-dia-on').forEach((cb) => {
    cb.addEventListener('change', () => {
      const row = cb.closest('[data-serv-dia]');
      if (!row) return;
      const wrap = row.querySelector('.serv-dia-tramos');
      const addBtn = row.querySelector('.serv-add-tramo');
      const show = cb.checked;
      if (wrap) wrap.classList.toggle('hidden', !show);
      if (addBtn) addBtn.classList.toggle('hidden', !show);
    });
  });
  document.querySelectorAll('.serv-add-tramo').forEach((btn) => {
    btn.addEventListener('click', () => {
      const row = btn.closest('[data-serv-dia]');
      if (!row) return;
      const wrap = row.querySelector('.serv-dia-tramos');
      if (!wrap || wrap.querySelectorAll('.serv-tramo').length >= 2) return;
      wrap.insertAdjacentHTML('beforeend', htmlTramoHorario('09:00', '18:00'));
    });
  });
}

const WA_COMPRA_TARJETAS_MSJ = 'Hola quiero comprar mas tarjetas';

function waTelCompraTarjetasSaldo() {
  const d = String(import.meta.env.VITE_WHATSAPP_TARJETAS_SALDO || '').replace(/\D/g, '');
  return d || '5491162399695';
}

function htmlOpcionesRubro({ selected, emptyLabel, excludeIds }) {
  const ex = new Set(excludeIds || []);
  let out = `<option value="">${esc(emptyLabel)}</option>`;
  for (const c of CATEGORIAS_SERVICIOS) {
    if (ex.has(c.id)) continue;
    const sel = c.id === selected ? ' selected' : '';
    out += `<option value="${esc(c.id)}"${sel}>${esc(c.label)}</option>`;
  }
  return out;
}

/** Icono decorativo (assets en `public/servicios/`, WebP). */
const ASSET_SERV_TARJETAS_ICON = '/servicios/tarjetas-naipe-icon.webp';
/** Miniatura fila “ver tarjetas” en cards del listado (reemplazable por PNG propio en esta ruta). */
const ASSET_SERV_TARJETAS_ROW = '/servicios/tarjetas-deck-row.webp';
const ASSET_SERV_TARJETA_PLANTILLA = '/servicios/tarjeta-trabajo-plantilla.webp';

function thumbPrimeraTarjetaDoc(t) {
  const a = listaItemsFotosTarjeta(t?.fotos_antes);
  const d = listaItemsFotosTarjeta(t?.fotos_despues);
  const u = normalizarUrlImagenServicios(String(urlDesdeItemFotoTarjeta(a[0]) || urlDesdeItemFotoTarjeta(d[0]) || ''));
  return u || ASSET_SERV_TARJETA_PLANTILLA;
}

function primeraUrlHttpTarjetaOPlantilla(t) {
  const list = [...urlsHttpTarjeta(t.fotos_antes || []), ...urlsHttpTarjeta(t.fotos_despues || [])];
  if (list[0]) return list[0];
  return ASSET_SERV_TARJETA_PLANTILLA;
}

/** Normaliza URLs guardadas o copiadas (espacios, entidades HTML). */
function normalizarUrlImagenServicios(raw) {
  let s = String(raw ?? '').trim().replace(/\s+/g, '');
  s = s.replace(/&amp;/gi, '&').replace(/&#38;/g, '&');
  s = s.replace(/[\u200B-\u200D\uFEFF]/g, '');
  return s;
}

/** Lista desde array Firestore o mapa tipo { 0: x, 1: y } (serialización legada). */
function listaItemsFotosTarjeta(v) {
  if (!v) return [];
  if (Array.isArray(v)) return v;
  if (typeof v === 'object') {
    const keys = Object.keys(v)
      .filter((k) => /^\d+$/.test(k))
      .sort((a, b) => Number(a) - Number(b));
    if (keys.length) return keys.map((k) => v[k]);
  }
  return [];
}

function urlDesdeItemFotoTarjeta(x) {
  if (x == null || x === '') return '';
  if (typeof x === 'string') return normalizarUrlImagenServicios(x);
  if (typeof x === 'object') {
    const cand = x.url ?? x.downloadURL ?? x.downloadUrl ?? x.href ?? x.src ?? '';
    return cand ? normalizarUrlImagenServicios(String(cand)) : '';
  }
  return normalizarUrlImagenServicios(String(x));
}

/** URLs de Storage listas para usar en <img> (evita strings vacíos o no-http). */
function urlsHttpTarjeta(arrOrObj) {
  return listaItemsFotosTarjeta(arrOrObj)
    .map(urlDesdeItemFotoTarjeta)
    .filter((u) => /^https?:\/\//i.test(u) || u.startsWith('//'));
}

function servFichaCeldaFoto(url) {
  const u = normalizarUrlImagenServicios(url);
  if (!/^https?:\/\//i.test(u) && !u.startsWith('//')) {
    return '<div class="aspect-square w-full rounded-lg bg-slate-100 ring-1 ring-slate-200/80" aria-hidden="true"></div>';
  }
  return `<img alt="" class="serv-ficha-tj-img aspect-square w-full rounded-lg object-cover ring-1 ring-slate-200" loading="eager" decoding="async" src="${esc(u)}" />`;
}

function htmlFichaTarjetaAntesDespues(t) {
  const antes = urlsHttpTarjeta(t.fotos_antes).slice(0, 2);
  const despues = urlsHttpTarjeta(t.fotos_despues).slice(0, 2);
  const fila = (titulo, urls) => {
    const u0 = urls[0] || '';
    const u1 = urls[1] || '';
    return `<div>
      <p class="mb-1.5 text-[10px] font-bold uppercase tracking-wide text-slate-500">${titulo}</p>
      <div class="grid grid-cols-2 gap-2">${servFichaCeldaFoto(u0)}${servFichaCeldaFoto(u1)}</div>
    </div>`;
  };
  return `<div class="mt-3 space-y-4">${fila('Antes', antes)}${fila('Después', despues)}</div>`;
}

function htmlFichaTarjetaValoracion(t) {
  const n = Number(t.reseña_estrellas);
  const tieneEst = Number.isFinite(n) && n >= 1 && n <= 5;
  const full = tieneEst ? Math.min(5, Math.max(1, Math.round(n))) : 0;
  const txt = String(t.reseña_texto || '').trim();
  let cuerpo = '';
  if (tieneEst) {
    cuerpo += `<div class="mt-2 flex flex-wrap items-center gap-2" aria-label="${full} de 5 estrellas">
      <span class="text-lg leading-none text-amber-500">${'★'.repeat(full)}</span>
      <span class="text-xs font-semibold text-slate-600">${full}/5</span>
    </div>`;
  }
  if (txt) {
    cuerpo += `<blockquote class="mt-2 border-l-2 border-brand-primary/45 pl-3 text-sm leading-relaxed text-slate-700"><p class="italic">"${esc(txt)}"</p></blockquote>`;
  }
  if (!cuerpo) {
    cuerpo =
      '<p class="mt-1.5 text-xs leading-relaxed text-slate-500">Todavía no hay valoración del cliente en la app. Si deja estrellas y comentario, se van a mostrar acá.</p>';
  }
  return `<div class="mt-4 rounded-xl bg-slate-50 p-3 ring-1 ring-slate-100">
    <p class="text-[10px] font-bold uppercase tracking-wide text-slate-500">Valoración del cliente</p>
    ${cuerpo}
  </div>`;
}

/** Lee URL colocada en data-fire-url (legado). */
function urlDesdeDataFireAttr(raw) {
  const s = normalizarUrlImagenServicios(String(raw ?? '').trim());
  if (!s) return '';
  if (/^https?:\/\//i.test(s) || s.startsWith('//') || s.startsWith('/')) return s;
  try {
    return normalizarUrlImagenServicios(decodeURIComponent(s));
  } catch {
    return s;
  }
}

function reemplazarImgTarjetaServicioPorPlaceholder(img) {
  const ph = document.createElement('div');
  ph.className = img.classList.contains('serv-tr-gal-img')
    ? 'h-24 w-24 rounded-xl bg-slate-100 ring-1 ring-slate-200/80'
    : 'aspect-square w-full rounded-lg bg-slate-100 ring-1 ring-slate-200/80';
  ph.setAttribute('aria-hidden', 'true');
  img.replaceWith(ph);
}

function wireErrorFallbackTarjetaFichaImg(img) {
  if (!(img instanceof HTMLImageElement)) return;
  function onTarjImgErr() {
    const plantilla = ASSET_SERV_TARJETA_PLANTILLA;
    let yaPlantilla = false;
    try {
      const abs = new URL(plantilla, window.location.origin).href;
      yaPlantilla = img.src === abs || img.src.endsWith(plantilla);
    } catch {
      yaPlantilla = img.src.includes('tarjeta-trabajo-plantilla');
    }
    if (img.dataset.mlvServTjPlantIntent === '1' || yaPlantilla) {
      img.removeEventListener('error', onTarjImgErr);
      reemplazarImgTarjetaServicioPorPlaceholder(img);
      return;
    }
    img.dataset.mlvServTjPlantIntent = '1';
    img.src = plantilla;
  }
  img.addEventListener('error', onTarjImgErr);
}

/**
 * Tarjetas / galería: src ya viene en el HTML; solo legado data-fire-url y fallback si falla la red.
 * No toca .serv-mp-slot-thumb (Mi perfil tiene su propio onerror → plantilla).
 */
function aplicarSrcDataFireUrlImgsTarjetaFicha(scopeEl) {
  const root = scopeEl || document;
  root
    .querySelectorAll(
      '.serv-ficha-tj-img[data-fire-url], .serv-tr-gal-img[data-fire-url], .serv-mp-slot-thumb[data-fire-url], .serv-pro-avatar-img[data-fire-url]'
    )
    .forEach((img) => {
      if (!(img instanceof HTMLImageElement)) return;
      const raw = img.getAttribute('data-fire-url');
      img.removeAttribute('data-fire-url');
      const url = urlDesdeDataFireAttr(raw);
      if (!url) {
        if (!img.classList.contains('serv-mp-slot-thumb')) reemplazarImgTarjetaServicioPorPlaceholder(img);
        return;
      }
      img.src = url;
    });

  root.querySelectorAll('.serv-ficha-tj-img:not(.serv-mp-slot-thumb), .serv-tr-gal-img').forEach((img) => {
    if (!(img instanceof HTMLImageElement) || !img.getAttribute('src')) return;
    if (img.dataset.mlvServTjErr === '1') return;
    img.dataset.mlvServTjErr = '1';
    wireErrorFallbackTarjetaFichaImg(img);
  });
}

function iconRocketMp() {
  return `<svg class="h-5 w-5 shrink-0 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 01-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 006.16-12.12A14.98 14.98 0 009.631 8.41m5.96 5.96a14.926 14.926 0 01-5.841 2.58m-.119-8.54a6 6 0 00-7.281 5.119v4.8a6 6 0 007.281 5.119 14.98 14.98 0 0012.12-6.16 14.98 14.98 0 00-6.16-12.12z"/></svg>`;
}

function iconBack() {
  return `<svg class="h-6 w-6 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" /></svg>`;
}

function tsMs(v) {
  if (v?.toMillis) return v.toMillis();
  if (typeof v?.seconds === 'number') return v.seconds * 1000;
  return 0;
}

function truncText(s, max) {
  const t = String(s || '').trim();
  if (t.length <= max) return t;
  return `${t.slice(0, max - 1)}…`;
}

/** URL para src de avatar (entidades tipo &amp; y solo http/https). */
function urlFotoPerfilLista(raw) {
  let s = normalizarUrlImagenServicios(raw);
  if (!s) return '';
  if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) s = s.slice(1, -1);
  s = normalizarUrlImagenServicios(s);
  if (!/^https?:\/\//i.test(s)) return '';
  try {
    const x = new URL(s);
    if (x.protocol !== 'http:' && x.protocol !== 'https:') return '';
    return s;
  } catch {
    return s;
  }
}

function montarPlaceholderFotoServMp(wrap) {
  if (!wrap) return;
  wrap.style.backgroundImage = '';
  wrap.replaceChildren();
  const ini = wrap.getAttribute('data-initials') || '?';
  const ph = document.createElement('div');
  ph.id = 'serv-mp-foto-placeholder';
  ph.className =
    'flex h-full w-full flex-col items-center justify-center bg-gradient-to-br from-[#0a5c5f] via-brand-primary to-emerald-900 text-center text-white shadow-inner';
  const t1 = document.createElement('span');
  t1.className = 'text-2xl font-bold tracking-tight';
  t1.textContent = ini;
  const t2 = document.createElement('span');
  t2.className = 'mt-1 text-[9px] font-semibold uppercase tracking-wide text-white/85';
  t2.textContent = 'Foto';
  ph.appendChild(t1);
  ph.appendChild(t2);
  wrap.appendChild(ph);
}

/** Foto perfil servicios: img en DOM (como fichas); si falla la red, iniciales. */
function aplicarFondoFotoServMp(url) {
  const wrap = document.getElementById('serv-mp-foto-wrap');
  if (!wrap || !url) return;
  const fixed = normalizarUrlImagenServicios(url);
  if (!/^https?:\/\//i.test(fixed) && !fixed.startsWith('//')) return;
  wrap.replaceChildren();
  wrap.style.backgroundImage = '';
  const img = document.createElement('img');
  img.alt = '';
  img.decoding = 'async';
  img.className = 'serv-mp-foto-prev h-full w-full object-cover';
  img.addEventListener(
    'error',
    () => {
      montarPlaceholderFotoServMp(wrap);
    },
    { once: true }
  );
  img.src = fixed;
  wrap.appendChild(img);
}

/** @param {object[]} tarjetas */
function resumenResenasTarjetas(tarjetas) {
  const list = Array.isArray(tarjetas) ? tarjetas : [];
  const conEst = list.filter((t) => t?.reseña_estrellas != null && Number.isFinite(Number(t.reseña_estrellas)));
  const avg =
    conEst.length > 0
      ? conEst.reduce((s, t) => s + Number(t.reseña_estrellas), 0) / conEst.length
      : null;
  const conTexto = list.find((t) => String(t?.reseña_texto || '').trim());
  const snippet = conTexto ? truncText(conTexto.reseña_texto, 72) : '';
  return { avg, snippet };
}

function iconChevronServ() {
  return `<svg class="serv-disp-chev h-3.5 w-3.5 shrink-0 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" /></svg>`;
}

function iconChevronRightServ() {
  return `<svg class="serv-disp-chev h-4 w-4 shrink-0 transition-transform" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>`;
}

function esDestacadoServicios(p) {
  return (Number(p?.tarjetas_saldo) || 0) > 0 || p?.servicios_premium === true;
}

/** Card expandida en listado: destacado comercial o ya tiene tarjetas publicadas. */
function esCardServiciosExpandida(p, tarjetas) {
  if (esDestacadoServicios(p)) return true;
  return Array.isArray(tarjetas) && tarjetas.length > 0;
}

function iconWaServCard() {
  return mlvPng('whatsapp', 'h-5 w-5 shrink-0 object-contain brightness-0 invert', { w: 20, h: 20 });
}

function badgeVerificadoServPro() {
  return `<span class="pointer-events-none absolute -bottom-0.5 -right-0.5 z-[2] flex h-6 w-6 items-center justify-center rounded-full bg-brand-secondary shadow-md ring-2 ring-white" title="Profesional verificado">
    <svg class="h-3.5 w-3.5 text-brand-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
  </span>`;
}

/**
 * @param {object} opts
 * @param {(html: string) => void} opts.render
 * @param {() => object} opts.getFirebase
 * @param {ReturnType<import('../data/serviciosRepository.js').createServiciosRepository>} opts.serviciosRepository
 * @param {{ syncUserProfile: (uid: string, email: string|null) => Promise<object> }} opts.vendedorRepository
 * @param {() => object} opts.getNavigation
 */
export function createServiciosPresenters({ render, getFirebase, serviciosRepository, vendedorRepository, getNavigation }) {
  async function abrirWhatsappProfesional({ telefono, nombre }) {
    const tel = String(telefono || '').replace(/\D/g, '');
    if (!tel) {
      window.alert('Este perfil no tiene WhatsApp cargado.');
      return;
    }
    const nombreTrim = String(nombre || '').trim();
    let tagPart = '';
    const auth = getFirebase().auth.currentUser;
    if (auth?.uid) {
      try {
        const perfilU = await vendedorRepository.syncUserProfile(auth.uid, auth.email || null);
        const tag = String(perfilU?.user_tag || '').trim();
        if (tag) {
          tagPart = ` Mi tag vecino es ${tag} (para anotarlo cuando cargues la tarjeta).`;
        }
      } catch (e) {
        console.warn('WhatsApp servicios: no se pudo leer user_tag', e);
      }
    }
    const msg = `Hola ${nombreTrim}, te encontré en Mercado La Victoria (servicios).${tagPart}`.trim();
    const url = buildWhatsAppUrl(tel, msg);
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
  }

  function modalDisclaimerAntesWhatsapp(onContinuar) {
    const prev = document.getElementById('mlv-serv-wa-disclaimer');
    prev?.remove();
    const wrap = document.createElement('div');
    wrap.id = 'mlv-serv-wa-disclaimer';
    wrap.className = 'fixed inset-0 z-[300] flex items-end justify-center bg-black/50 p-4 sm:items-center';
    wrap.innerHTML = `
      <div class="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-t-3xl bg-white p-5 shadow-xl sm:rounded-3xl">
        <h2 class="font-heading text-lg font-bold text-slate-900">Salís de la app</h2>
        <p class="mt-3 text-sm leading-relaxed text-slate-600">
          Vas a abrir <strong class="text-slate-800">WhatsApp</strong> para hablar con el profesional. El acuerdo, precio y trabajo son entre ustedes.
          La app no interviene ni garantiza el resultado.
        </p>
        <p class="mt-2 text-xs text-slate-500">Cuidá tus datos personales y acordá condiciones por escrito si hace falta.</p>
        <div class="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button type="button" id="mlv-serv-wa-cancel" class="rounded-xl border border-slate-200 py-3 text-sm font-semibold text-slate-700">Cancelar</button>
          <button type="button" id="mlv-serv-wa-ok" class="rounded-xl bg-brand-primary py-3 text-sm font-bold text-white">Continuar a WhatsApp</button>
        </div>
      </div>`;
    document.body.appendChild(wrap);
    wrap.querySelector('#mlv-serv-wa-cancel')?.addEventListener('click', () => wrap.remove());
    wrap.querySelector('#mlv-serv-wa-ok')?.addEventListener('click', () => {
      wrap.remove();
      onContinuar?.();
    });
    wrap.addEventListener('click', (e) => {
      if (e.target === wrap) wrap.remove();
    });
  }

  async function showServiciosHome() {
    const nav = getNavigation();
    const u = getFirebase().auth.currentUser;
    if (!u) {
      nav.pushLoginShow();
      return;
    }
    let lista = [];
    try {
      lista = await serviciosRepository.listarProfesionales({ max: 80 });
    } catch (e) {
      console.error(e);
    }
    let tienePerfilProfesional = false;
    try {
      const miProf = await serviciosRepository.obtenerProfesional(u.uid);
      tienePerfilProfesional = Boolean(
        miProf && Array.isArray(miProf.rubros) && miProf.rubros.length > 0
      );
    } catch (e) {
      console.warn(e);
    }
    const validos = lista.filter(
      (p) =>
        Array.isArray(p.rubros) &&
        p.rubros.length > 0 &&
        p.perfil_publico !== false
    );
    validos.sort((a, b) => {
      const dest = (p) =>
        (Number(p.tarjetas_saldo) || 0) > 0 || p.servicios_premium === true ? 1 : 0;
      const pa = dest(a);
      const pb = dest(b);
      if (pb !== pa) return pb - pa;
      return tsMs(b.actualizadoEn) - tsMs(a.actualizadoEn);
    });

    let filtroRubro = '';
    let filtroTxt = '';
    let filtroSoloHoy = false;
    /** @type {Set<number>} */
    let filtroDiasSemana = new Set();

    function cumpleFiltroDisponibilidadHome(p) {
      if (filtroSoloHoy) {
        const hoy = diaSemanaMLVDesdeDate();
        if (!perfilTieneDisponibilidadEnDia(p, hoy)) return false;
      }
      for (const d of filtroDiasSemana) {
        if (d < 0 || d > 6) continue;
        if (!perfilTieneDisponibilidadEnDia(p, d)) return false;
      }
      return true;
    }

    function filtrados() {
      const t = filtroTxt.trim().toLowerCase();
      return validos.filter((p) => {
        if (filtroRubro && !(p.rubros || []).includes(filtroRubro)) return false;
        if (!cumpleFiltroDisponibilidadHome(p)) return false;
        if (!t) return true;
        const labels = (p.rubros || []).map((id) => labelRubroServicio(id).toLowerCase());
        const blob = `${(p.nombre_publico || '').toLowerCase()} ${labels.join(' ')} ${(p.descripcion_publica || '').toLowerCase()} ${textoDisponibilidadParaPublico(p).toLowerCase()}`;
        return blob.includes(t);
      });
    }

    function resumenTextoFiltroDias() {
      if (!filtroDiasSemana.size) return 'Disponibles en… (elegí uno o más días)';
      const ordenados = [...filtroDiasSemana].sort((a, b) => a - b);
      const cortos = ordenados
        .map((id) => DIAS_SEMANA_ORDEN.find((x) => x.id === id)?.labelCorto || '')
        .filter(Boolean);
      return `Días: ${cortos.join(', ')}`;
    }

    function htmlFiltrosDisponibilidadHome() {
      const diasChecks = DIAS_SEMANA_ORDEN.map(
        ({ id, label }) =>
          `<label class="flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-slate-50">
            <input type="checkbox" class="serv-filtro-dia h-4 w-4 rounded border-slate-300 accent-brand-primary" data-dia="${id}"${
              filtroDiasSemana.has(id) ? ' checked' : ''
            } />
            <span class="text-sm text-slate-800">${esc(label)}</span>
          </label>`
      ).join('');
      return `
        <div class="mt-3 rounded-2xl border border-slate-200/90 bg-white/90 p-3 shadow-sm ring-1 ring-slate-100/80">
          <p class="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Disponibilidad</p>
          <label class="mt-2 flex cursor-pointer items-center gap-2">
            <input type="checkbox" id="serv-filtro-hoy" class="h-4 w-4 rounded border-slate-300 accent-brand-primary"${
              filtroSoloHoy ? ' checked' : ''
            } />
            <span class="text-sm font-medium text-slate-800">Disponibles hoy</span>
          </label>
          <p class="mt-1 text-[11px] leading-snug text-slate-500">Solo perfiles con horario cargado para el día de hoy.</p>
          <details class="serv-filtro-dias-details group mt-3 rounded-xl border border-slate-200 bg-slate-50/80 open:bg-white">
            <summary class="cursor-pointer list-none px-3 py-2.5 text-sm font-semibold text-slate-800 marker:hidden [&::-webkit-details-marker]:hidden">
              <span class="flex items-center justify-between gap-2">
                <span id="serv-filtro-dias-summary">${esc(resumenTextoFiltroDias())}</span>
                <span class="text-xs font-normal text-brand-primary group-open:hidden">Abrir</span>
                <span class="hidden text-xs font-normal text-slate-500 group-open:inline">Cerrar</span>
              </span>
            </summary>
            <div class="border-t border-slate-200/80 px-2 py-2">
              <p class="px-2 pb-1 text-[11px] text-slate-500">Mostrar quienes tienen turno en <strong class="text-slate-700">todos</strong> los días marcados.</p>
              <div class="grid grid-cols-1 gap-0.5 sm:grid-cols-2">${diasChecks}</div>
              <button type="button" id="serv-filtro-dias-limpiar" class="mt-2 w-full rounded-lg py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-100">Quitar selección de días</button>
            </div>
          </details>
        </div>`;
    }

    function datosBaseProCard(p, viewerCtx) {
      const uidEsc = esc(p.id);
      const nombre = String(p.nombre_publico || 'Profesional').trim() || 'Profesional';
      const nombreEsc = esc(nombre);
      const rubrosLabels = (p.rubros || []).map((id) => labelRubroServicio(id));
      const primero = rubrosLabels[0] || 'Profesional';
      const disp =
        textoDisponibilidadParaPublico(p).trim() || 'Consultá horarios y urgencias por WhatsApp.';
      const initialsRaw = initialsFromNameEmail(nombre, '');
      const iniciales = esc(initialsRaw);
      let fotoProf = urlFotoPerfilLista(p.foto_perfil_servicios_url);
      const fotoAuthFb =
        viewerCtx?.viewerUid && p.id === viewerCtx.viewerUid
          ? urlFotoPerfilLista(viewerCtx.viewerPhotoURL)
          : '';
      if (!fotoProf && fotoAuthFb) fotoProf = fotoAuthFb;
      const avatarFbAuthAttr =
        fotoProf && fotoAuthFb && fotoAuthFb !== fotoProf ? esc(fotoAuthFb) : '';
      const avatarInner = fotoProf
        ? `<img alt="" class="serv-pro-avatar-img absolute inset-0 z-0 h-full w-full max-w-none object-cover" decoding="async" src="${esc(fotoProf)}" />`
        : `<span class="absolute inset-0 z-0 flex items-center justify-center text-sm font-bold" aria-hidden="true">${iniciales}</span>`;
      const telEsc = esc(String(p.telefono_whatsapp || '').trim());
      return { uidEsc, nombreEsc, primero, disp, iniciales, avatarInner, avatarFbAuthAttr, telEsc };
    }

    function buildProCardHtml(p, tarjetas, viewerCtx) {
      const base = datosBaseProCard(p, viewerCtx);
      const { uidEsc, nombreEsc, primero, disp, iniciales, avatarInner, avatarFbAuthAttr, telEsc } = base;

      if (!esCardServiciosExpandida(p, tarjetas)) {
        const attrFb = avatarFbAuthAttr ? ` data-avatar-fb-auth="${avatarFbAuthAttr}"` : '';
        return `
      <article class="serv-pro-card serv-pro-card--compact cursor-pointer rounded-2xl border border-slate-200/90 bg-white px-4 py-3 shadow-sm ring-1 ring-slate-100/80 transition hover:shadow-md" data-uid="${uidEsc}">
        <div class="flex items-center gap-3">
          <div class="serv-pro-avatar-wrap relative h-14 w-14 shrink-0 overflow-hidden rounded-full bg-gradient-to-br from-brand-primary/20 via-white to-brand-primary/10 text-sm font-bold text-brand-primary" data-initials="${iniciales}"${attrFb}>${avatarInner}</div>
          <div class="min-w-0 flex-1">
            <h2 class="font-heading text-sm font-bold leading-tight text-slate-900 sm:text-base">${nombreEsc}</h2>
            <p class="mt-0.5 text-xs text-slate-500 sm:text-sm">${esc(primero)}</p>
          </div>
          <button type="button" class="serv-toggle-disp inline-flex shrink-0 items-center gap-1 text-xs font-semibold text-brand-primary hover:underline sm:text-sm" aria-expanded="false">
            <span class="whitespace-nowrap">Ver disponibilidad</span>
            ${iconChevronRightServ()}
          </button>
        </div>
        <div class="serv-disp-panel hidden mt-3 rounded-xl bg-slate-50/90 px-3 py-2 text-sm leading-relaxed text-slate-700 ring-1 ring-slate-100">${esc(disp)}</div>
      </article>`;
      }

      const tituloLine = p.perfil_validado === true ? `${primero} certificado` : primero;
      const badgeServPremium = `<span class="inline-flex shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-amber-900">Destacado</span>`;
      const { avg, snippet } = resumenResenasTarjetas(tarjetas);
      const ratingHtml =
        avg != null
          ? `<span class="inline-flex shrink-0 items-center gap-0.5 rounded-full bg-brand-primary px-2 py-0.5 text-[11px] font-bold text-white shadow-sm"><span class="text-amber-300" aria-hidden="true">★</span>${esc(avg.toFixed(1))}</span>`
          : '';

      const frasePerfil = String(p.frase_personal || '').trim();
      const fraseHtml = frasePerfil
        ? `<p class="mt-2 text-sm leading-snug text-slate-600">${esc(truncText(frasePerfil, 96))}</p>`
        : snippet
          ? `<p class="mt-2 text-sm italic leading-snug text-slate-500">"${esc(snippet)}"</p>`
          : '';

      const verifBadge = p.perfil_validado === true ? badgeVerificadoServPro() : '';
      const tarjetasRowIcon = `<div class="flex h-[4.5rem] w-[5.5rem] shrink-0 items-center justify-center overflow-hidden rounded-xl bg-slate-100 p-1.5 ring-1 ring-slate-200/90">
            <img src="${ASSET_SERV_TARJETAS_ROW}" alt="" width="88" height="88" class="h-full w-full object-contain object-center" loading="lazy" decoding="async" />
          </div>`;
      const attrFb = avatarFbAuthAttr ? ` data-avatar-fb-auth="${avatarFbAuthAttr}"` : '';

      return `
      <article class="serv-pro-card serv-pro-card--full cursor-pointer rounded-2xl border border-slate-200/90 bg-white p-4 shadow-sm ring-1 ring-slate-100/80 transition hover:shadow-md" data-uid="${uidEsc}">
        <div class="flex gap-3">
          <div class="relative shrink-0">
            <div class="serv-pro-avatar-wrap relative h-[4.25rem] w-[4.25rem] overflow-hidden rounded-xl bg-gradient-to-br from-brand-primary/20 via-white to-brand-primary/10 text-base font-bold text-brand-primary ring-1 ring-slate-200/60" data-initials="${iniciales}"${attrFb}>${avatarInner}</div>
            ${verifBadge}
          </div>
          <div class="min-w-0 flex-1">
            <div class="flex items-start justify-between gap-2">
              <div class="min-w-0">
                <div class="flex flex-wrap items-center gap-2">
                  <h2 class="font-heading text-base font-bold leading-tight text-slate-900">${nombreEsc}</h2>
                  ${badgeServPremium}
                </div>
                <p class="mt-0.5 text-sm font-semibold text-brand-primary">${esc(tituloLine)}</p>
              </div>
              ${ratingHtml}
            </div>
            ${fraseHtml}
          </div>
        </div>
        <div class="mt-4 border-t border-slate-200/80 pt-3">
          <div class="rounded-xl bg-slate-100/90 px-3 py-3 ring-1 ring-slate-200/55">
          <div class="flex items-center justify-between gap-2">
            <span class="text-[10px] font-bold uppercase tracking-wide text-slate-500">Tarjetas del profesional</span>
            <button type="button" class="serv-toggle-disp inline-flex items-center gap-0.5 text-xs font-semibold text-brand-primary hover:underline" aria-expanded="false">
              Ver disponibilidad
              ${iconChevronServ()}
            </button>
          </div>
          <div class="serv-disp-panel hidden mt-2 rounded-xl bg-white/90 px-3 py-2 text-sm leading-relaxed text-slate-700 ring-1 ring-slate-100">${esc(disp)}</div>
          <div class="mt-3 flex items-center gap-3">
            ${tarjetasRowIcon}
            <p class="min-w-0 flex-1 text-sm leading-snug text-slate-600">Revisá las tarjetas del profesional</p>
          </div>
          </div>
        </div>
        <button type="button" class="serv-wa mt-4 flex w-full items-center justify-center gap-2 rounded-full bg-[#25D366] py-3.5 text-sm font-bold text-white shadow-md transition hover:brightness-105 active:scale-[0.99]" data-tel="${telEsc}" data-nombre="${nombreEsc}">
          ${iconWaServCard()}
          Contactar por WhatsApp
        </button>
      </article>`;
    }

    function wireServiciosHomeChrome() {
      document.getElementById('serv-home-back')?.addEventListener('click', () => nav.goBack());
      document.getElementById('serv-home-mi')?.addEventListener('click', () => nav.pushServiciosMiPerfil());
      document.getElementById('serv-home-cta-registro')?.addEventListener('click', () => nav.pushServiciosMiPerfil());
      document.getElementById('serv-home-cta-editar')?.addEventListener('click', () => nav.pushServiciosMiPerfil());
      document.getElementById('serv-buscar')?.addEventListener('input', (e) => {
        filtroTxt = e.target.value || '';
        void paint();
      });
      document.getElementById('serv-filtro-hoy')?.addEventListener('change', (e) => {
        filtroSoloHoy = e.target.checked === true;
        void paint();
      });
      document.querySelectorAll('.serv-filtro-dia').forEach((cb) => {
        cb.addEventListener('change', () => {
          const next = new Set();
          document.querySelectorAll('.serv-filtro-dia:checked').forEach((x) => {
            const id = Number(x.getAttribute('data-dia'));
            if (!Number.isNaN(id) && id >= 0 && id <= 6) next.add(id);
          });
          filtroDiasSemana = next;
          void paint();
        });
      });
      document.getElementById('serv-filtro-dias-limpiar')?.addEventListener('click', () => {
        filtroDiasSemana = new Set();
        void paint();
      });
      document.querySelectorAll('.serv-pill').forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.getAttribute('data-rubro') || '';
          filtroRubro = filtroRubro === id ? '' : id;
          void paint();
        });
      });
    }

    function wireServiciosProCards() {
      document.querySelectorAll('.serv-pro-card').forEach((card) => {
        card.addEventListener('click', (e) => {
          const t = e.target;
          if (t.closest('.serv-wa') || t.closest('.serv-toggle-disp')) return;
          const uid = card.getAttribute('data-uid');
          if (uid) nav.pushServiciosFicha(uid);
        });
      });
      document.querySelectorAll('.serv-toggle-disp').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const card = btn.closest('.serv-pro-card');
          const panel = card?.querySelector('.serv-disp-panel');
          const chev = btn.querySelector('.serv-disp-chev');
          panel?.classList.toggle('hidden');
          const open = panel && !panel.classList.contains('hidden');
          btn.setAttribute('aria-expanded', String(open));
          const compact = card?.classList.contains('serv-pro-card--compact');
          if (compact) {
            chev?.classList.toggle('rotate-90', Boolean(open));
          } else {
            chev?.classList.toggle('rotate-180', Boolean(open));
          }
        });
      });
      document.querySelectorAll('.serv-wa').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const tel = btn.getAttribute('data-tel') || '';
          const nombre = btn.getAttribute('data-nombre') || '';
          modalDisclaimerAntesWhatsapp(() => abrirWhatsappProfesional({ telefono: tel, nombre }));
        });
      });
      document.querySelectorAll('.serv-pro-avatar-img').forEach((img) => {
        const wrap = img.closest('.serv-pro-avatar-wrap');
        const initials = wrap?.getAttribute('data-initials') || '?';
        img.addEventListener('error', () => {
          const fbRaw = wrap?.getAttribute('data-avatar-fb-auth')?.trim();
          const fb = fbRaw ? urlDesdeDataFireAttr(fbRaw) : '';
          if (fb && img.dataset.triedFbAuth !== '1') {
            img.dataset.triedFbAuth = '1';
            img.src = fb;
            return;
          }
          if (!wrap || wrap.getAttribute('data-avatar-fallback') === '1') return;
          wrap.setAttribute('data-avatar-fallback', '1');
          img.remove();
          const sp = document.createElement('span');
          sp.className =
            'absolute inset-0 z-0 flex items-center justify-center text-base font-bold text-brand-primary';
          sp.setAttribute('aria-hidden', 'true');
          sp.textContent = initials;
          wrap.appendChild(sp);
        });
      });
    }

    async function paint() {
      const items = filtrados();
      const pills = CATEGORIAS_SERVICIOS.slice(0, 12)
        .map(
          (c) =>
            `<button type="button" class="serv-pill shrink-0 rounded-full border bg-white px-3 py-1.5 text-xs font-semibold transition ${
              filtroRubro === c.id
                ? 'border-2 border-slate-900 text-slate-900 shadow-sm'
                : 'border border-slate-200 text-slate-700 hover:border-slate-300'
            }" data-rubro="${esc(c.id)}">${esc(c.label)}</button>`
        )
        .join('');

      render(`
        <div class="min-h-screen bg-slate-100/90 mlv-bg-surface pb-28">
          <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
            <button type="button" id="serv-home-back" class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Volver">${iconBack()}</button>
            <h1 class="flex-1 text-center font-heading text-lg font-bold text-brand-primary">Servicios del barrio</h1>
            <button type="button" id="serv-home-mi" class="shrink-0 rounded-full bg-brand-primary/15 px-3 py-2 text-xs font-bold text-brand-primary">Mi perfil</button>
          </header>
          <main class="mx-auto max-w-lg px-4 pt-4">
            <input id="serv-buscar" type="search" placeholder="Buscar por nombre o rubro…" value="${esc(filtroTxt)}" class="w-full rounded-2xl border-0 bg-slate-200/60 py-3 px-4 text-sm ring-1 ring-slate-200/80" />
            ${htmlFiltrosDisponibilidadHome()}
            <div class="mt-3 flex gap-2 overflow-x-auto pb-2">${pills}</div>
            ${
              tienePerfilProfesional
                ? `<div class="mt-3 flex justify-end">
              <button type="button" id="serv-home-cta-editar" class="rounded-lg border border-brand-primary/35 bg-brand-primary/8 px-3 py-1.5 text-[11px] font-semibold text-brand-primary shadow-sm transition hover:bg-brand-primary/15">Editá tu perfil</button>
            </div>`
                : `<section class="relative mt-4 overflow-hidden rounded-2xl bg-brand-primary px-4 py-5 text-white shadow-md ring-1 ring-black/10" aria-label="Sumate como profesional">
              <img src="${ASSET_SERV_TARJETAS_ICON}" alt="" class="pointer-events-none absolute -bottom-3 -right-2 h-28 w-auto max-w-[45%] object-contain opacity-[0.18]" width="88" height="88" loading="lazy" decoding="async" />
              <div class="relative z-[1] max-w-[min(100%,20rem)]">
                <h2 class="font-heading text-lg font-bold leading-tight">Ofrecé tus servicios</h2>
                <p class="mt-1 text-sm text-white/90">Sumate a la red de confianza de tu barrio.</p>
                <button type="button" id="serv-home-cta-registro" class="mt-4 w-full rounded-xl bg-lime-400 py-3 text-sm font-bold text-slate-900 shadow-sm transition hover:brightness-105 active:scale-[0.99]">Registrarme</button>
              </div>
            </section>`
            }
            <div id="serv-cards-root" class="mt-4 space-y-4"></div>
          </main>
        </div>`);

      const root = document.getElementById('serv-cards-root');
      if (!root) return;

      wireServiciosHomeChrome();

      if (!items.length) {
        root.innerHTML = validos.length
          ? '<p class="text-sm text-slate-600">Ningún perfil coincide con los filtros. Probá otro rubro, quitá días o “Disponibles hoy”.</p>'
          : '<p class="text-sm text-slate-500">Todavía no hay perfiles publicados.</p>';
        return;
      }

      root.innerHTML =
        '<p class="py-6 text-center text-sm text-slate-500" role="status">Cargando tarjetas…</p>';

      const viewerCtx = {
        viewerUid: u?.uid || '',
        viewerPhotoURL: String(u?.photoURL || '').trim(),
      };

      const enriched = await Promise.all(
        items.map(async (p) => {
          let tarjetas = [];
          try {
            const r = await serviciosRepository.listarTarjetasVisibles(p.id, { pageSize: 3 });
            tarjetas = r.docs;
          } catch (err) {
            console.error(err);
          }
          return { p, tarjetas };
        })
      );

      if (!root.isConnected) return;
      root.innerHTML = enriched.map(({ p, tarjetas }) => buildProCardHtml(p, tarjetas, viewerCtx)).join('');
      aplicarSrcDataFireUrlImgsTarjetaFicha(root);
      wireServiciosProCards();
    }

    void paint();
  }

  async function showServiciosMiPerfil() {
    const nav = getNavigation();
    const u = getFirebase().auth.currentUser;
    if (!u) {
      nav.pushLoginShow();
      return;
    }
    const [perfilUsuario, prof, tarjetasPack] = await Promise.all([
      vendedorRepository.syncUserProfile(u.uid, u.email),
      serviciosRepository.obtenerProfesional(u.uid),
      serviciosRepository.listarTarjetasVisibles(u.uid, { pageSize: 4 }).catch(() => ({ docs: [] })),
    ]);
    const tarjList = Array.isArray(tarjetasPack?.docs) ? tarjetasPack.docs : [];
    const nombreInicial = String(perfilUsuario?.nombre || u.displayName || u.email || 'Usuario').trim();
    const inicialesMp = initialsFromNameEmail(nombreInicial, u.email || '');
    const tel = String(perfilUsuario?.telefono || '').trim();
    const esPremium = esCuentaPremiumPerfil(perfilUsuario);
    const verificado = prof?.perfil_validado === true;
    const expServiciosFull =
      (Number(prof?.tarjetas_saldo) || 0) > 0 ||
      tarjList.length > 0 ||
      prof?.servicios_premium === true;
    const rubrosActuales = normalizarRubrosPerfil(prof?.rubros || []);
    const r1 = rubrosActuales[0] || '';
    const r2 = rubrosActuales[1] || '';
    const r3 = rubrosActuales[2] || '';
    const fotoHiddenServicios = normalizarUrlImagenServicios(String(prof?.foto_perfil_servicios_url ?? ''));
    const fotoUrl =
      urlFotoPerfilLista(fotoHiddenServicios) ||
      urlFotoPerfilLista(perfilUsuario?.foto_url) ||
      urlFotoPerfilLista(u.photoURL) ||
      '';
    const fotoMostrar =
      fotoUrl ||
      (fotoHiddenServicios && /^https?:\/\//i.test(fotoHiddenServicios) ? fotoHiddenServicios : '') ||
      '';
    const saldoTarjetas = Number(prof?.tarjetas_saldo) || 0;
    const selloNegro = verificado ? 'Profesional verificado' : 'Perfil en el barrio';
    const fraseVal = String(prof?.frase_personal || '').trim();

    const opt1 = htmlOpcionesRubro({
      selected: r1,
      emptyLabel: 'Seleccionar especialidad',
      excludeIds: [],
    });
    const opt2 = htmlOpcionesRubro({
      selected: r2,
      emptyLabel: 'Segunda especialidad (opcional)',
      excludeIds: [r1],
    });
    const opt3 = htmlOpcionesRubro({
      selected: r3,
      emptyLabel: 'Tercera especialidad (opcional)',
      excludeIds: [r1, r2].filter(Boolean),
    });

    const bannerVerif = verificado
      ? `<div class="rounded-xl border border-emerald-200/90 bg-emerald-50/95 px-3 py-2.5 text-sm text-emerald-950 ring-1 ring-emerald-100">
          <p class="font-semibold">Profesión verificada</p>
          <p class="mt-0.5 text-xs leading-relaxed text-emerald-900/90">Tu identidad profesional fue validada. Mostrás la insignia en fichas y tarjetas.</p>
        </div>`
      : `<p class="text-xs leading-relaxed text-slate-500">La verificación la coordina el equipo cuando corresponda; podés usar el perfil mientras tanto.</p>`;

    const hintServiciosTier = expServiciosFull
      ? `<p class="mt-1 text-[11px] leading-snug text-slate-600">Tenés <strong class="font-semibold text-slate-800">destacado en servicios</strong>: hasta 3 rubros, frase personal, tarjetas con animación y prioridad en el listado.</p>`
      : `<p class="mt-1 text-[11px] leading-snug text-slate-600"><strong class="font-semibold text-slate-800">Plan estándar:</strong> una especialidad y disponibilidad para aparecer en el barrio. Para tarjetas y experiencia completa pedí <strong class="font-semibold text-slate-800">destacado en servicios</strong> a operaciones.</p>`;
    const hintMarket = esPremium
      ? `<p class="mt-1 text-[11px] leading-snug text-slate-500">Tu cuenta del catálogo tiene <strong class="text-slate-700">Premium</strong> (productos).</p>`
      : '';

    const slotVacioHtml = `<button type="button" class="serv-mp-slot serv-mp-slot-empty relative flex aspect-[5/8] w-full min-h-0 items-center justify-center overflow-hidden rounded-lg border border-dashed border-zinc-500/85 bg-zinc-900/55 text-lg font-light text-zinc-400 shadow-inner transition hover:border-brand-primary/65 hover:text-brand-primary sm:text-xl" data-slot-kind="empty" aria-label="Agregar tarjeta de trabajo">+</button>`;
    const slotsTarjetas = [];
    const MAX_TARJ_SLOTS = 5;
    for (let i = 0; i < MAX_TARJ_SLOTS; i++) {
      const t = tarjList[i];
      if (t) {
        const thumbUrl = primeraUrlHttpTarjetaOPlantilla(t);
        const thumbEnc = esc(thumbUrl);
        const imgSlot = `<img alt="" class="serv-mp-slot-thumb serv-ficha-tj-img pointer-events-none absolute inset-0 h-full w-full object-cover" loading="lazy" decoding="async" src="${esc(thumbUrl)}" />`;
        slotsTarjetas.push(
          `<button type="button" class="serv-mp-slot serv-mp-slot-filled relative aspect-[5/8] w-full min-h-0 overflow-hidden rounded-lg border border-amber-500/35 bg-zinc-800 shadow-md ring-1 ring-black/40 transition hover:ring-amber-500/65 focus:outline-none focus:ring-2 focus:ring-brand-primary/50" data-slot-kind="filled" data-tarjeta-id="${esc(t.id)}" data-thumb="${thumbEnc}" aria-label="Tarjeta de trabajo">${imgSlot}</button>`
        );
      } else {
        slotsTarjetas.push(slotVacioHtml);
      }
    }
    const tarjetasGridHtml = slotsTarjetas.join('');
    const bloqueTarjetasMiPerfil = expServiciosFull
      ? `<section class="overflow-hidden rounded-2xl shadow-lg ring-1 ring-zinc-900/20">
            <div class="bg-gradient-to-b from-zinc-800 via-zinc-900 to-zinc-950 px-4 pb-4 pt-3 text-white">
              <div class="flex items-start justify-between gap-2">
                <p class="text-[9px] font-bold uppercase tracking-[0.12em] text-zinc-400">${esc(selloNegro)}</p>
                <img id="serv-mp-deck-icon" src="${ASSET_SERV_TARJETAS_ICON}" alt="" width="88" height="88" class="h-11 w-auto shrink-0 object-contain opacity-95 drop-shadow-lg" loading="lazy" decoding="async" />
              </div>
              <h2 class="mt-1 font-heading text-lg font-bold leading-snug text-white">Tarjetas del profesional</h2>
              <p class="mt-0.5 text-sm font-medium text-zinc-300">Tus mejores trabajos</p>
              <div id="serv-mp-tarjetas-grid" class="mt-4 grid grid-cols-5 gap-1.5 sm:gap-2">${tarjetasGridHtml}</div>
              <p class="mt-4 text-xs leading-relaxed text-zinc-200">
                Tenés <strong class="text-white" id="serv-mp-saldo-inline">${saldoTarjetas}</strong> tarjetas disponibles para agregar.
                <button type="button" id="serv-mp-comprar-wa" class="font-bold text-white underline decoration-brand-primary/80 underline-offset-2 hover:text-brand-primary">Comprás más acá</button>.
              </p>
            </div>
          </section>`
      : `<section class="rounded-2xl border border-amber-200/90 bg-amber-50/60 p-4 ring-1 ring-amber-100/80">
            <p class="text-sm font-semibold text-amber-950">Tarjetas y animaciones</p>
            <p class="mt-1.5 text-xs leading-relaxed text-amber-900/90">Forman parte del <strong>destacado en servicios</strong>. Con plan estándar tu perfil y horarios siguen publicados; para el mazo de fotos antes/después y las transiciones, operaciones activa tu plan.</p>
          </section>`;

    render(`
      <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
        <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
          <button type="button" id="serv-mp-back" class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Volver">${iconBack()}</button>
          <span class="w-10 shrink-0" aria-hidden="true"></span>
        </header>
        <main class="mx-auto max-w-lg space-y-4 px-4 pb-8 pt-2">
          <div>
            <h1 class="font-heading text-2xl font-bold leading-tight text-slate-900">Perfil profesional</h1>
            <p class="mt-2 text-sm leading-relaxed text-slate-600">${
              expServiciosFull
                ? 'Experiencia completa: rubros, frase, disponibilidad y tarjetas de trabajos.'
                : 'Completá lo esencial para aparecer en Servicios del barrio.'
            }</p>
          </div>
          <p id="serv-mp-msg" class="min-h-[1.25rem] text-sm text-red-700"></p>

          <section class="rounded-2xl border border-slate-200/90 bg-white p-4 shadow-sm ring-1 ring-slate-100/80">
            <div class="mb-3 flex items-center gap-2 text-sm font-semibold text-slate-800">
              <span class="flex h-8 w-8 items-center justify-center rounded-full bg-brand-primary/10 text-brand-primary" aria-hidden="true">◎</span>
              Información básica
            </div>
            <div class="flex flex-col items-center">
              <label class="group relative block h-28 w-28 shrink-0 cursor-pointer">
                <input type="file" id="serv-mp-foto" accept="image/*" class="sr-only" aria-label="Subir foto profesional" />
                <div id="serv-mp-foto-wrap" data-initials="${esc(inicialesMp)}" class="relative h-28 w-28 overflow-hidden rounded-full bg-slate-100 shadow-md ring-2 ring-slate-200/90 ring-offset-2 ring-offset-white">
                  ${
                    fotoMostrar
                      ? ''
                      : `<div id="serv-mp-foto-placeholder" class="flex h-full w-full flex-col items-center justify-center bg-gradient-to-br from-[#0a5c5f] via-brand-primary to-emerald-900 text-center text-white shadow-inner">
                          <span class="text-2xl font-bold tracking-tight">${esc(inicialesMp)}</span>
                          <span class="mt-1 text-[9px] font-semibold uppercase tracking-wide text-white/85">Foto</span>
                        </div>`
                  }
                </div>
                <span class="pointer-events-none absolute bottom-0 right-0 z-[1] flex h-8 w-8 items-center justify-center rounded-full bg-brand-primary text-white shadow-md ring-2 ring-white" aria-hidden="true">
                  ${mlvPng('edit', 'h-4 w-4 object-contain brightness-0 invert', { w: 16, h: 16 })}
                </span>
              </label>
              <p id="serv-mp-foto-hint" class="mt-2 max-w-xs text-center text-xs text-slate-500">Subí una foto profesional para generar confianza.</p>
              <input type="hidden" id="serv-mp-foto-url" value="${esc(fotoHiddenServicios)}" />
            </div>
            <label class="mt-4 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Nombre completo</label>
            <input id="serv-mp-nombre" type="text" autocomplete="name" class="mt-1 w-full rounded-xl border-0 bg-slate-50 py-3 px-3 text-sm text-slate-900 ring-1 ring-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-primary/35" placeholder="Ej: Roberto García" value="${esc(nombreInicial)}" />
            <p class="mt-2 text-[11px] text-slate-500">WhatsApp público: el teléfono de tu perfil La Victoria <strong class="text-slate-700">${esc(tel || '—')}</strong>. Actualizalo desde Mi perfil si hace falta.</p>
          </section>

          <section class="rounded-2xl border border-slate-200/90 bg-white p-4 shadow-sm ring-1 ring-slate-100/80">
            <div class="mb-3 flex items-center gap-2 text-sm font-semibold text-slate-800">
              <span class="flex h-8 w-8 items-center justify-center rounded-full bg-brand-primary/10 text-brand-primary" aria-hidden="true">▢</span>
              Especialidad
            </div>
            ${bannerVerif}
            ${hintServiciosTier}
            ${hintMarket}
            <label class="mt-3 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Categoría principal</label>
            <select id="serv-mp-r1" class="mt-1 w-full appearance-none rounded-xl border-0 bg-slate-50 py-3 pl-3 pr-10 text-sm text-slate-900 ring-1 ring-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-primary/35">${opt1}</select>
            ${
              expServiciosFull
                ? `<label class="mt-3 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Otras especialidades</label>
            <select id="serv-mp-r2" class="mt-1 w-full appearance-none rounded-xl border-0 bg-slate-50 py-3 pl-3 pr-10 text-sm text-slate-900 ring-1 ring-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-primary/35">${opt2}</select>
            <select id="serv-mp-r3" class="mt-2 w-full appearance-none rounded-xl border-0 bg-slate-50 py-3 pl-3 pr-10 text-sm text-slate-900 ring-1 ring-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-primary/35">${opt3}</select>`
                : ''
            }
            <label class="mt-3 block text-[10px] font-bold uppercase tracking-wide text-slate-500">Disponibilidad</label>
            <p class="mt-1 text-[11px] leading-snug text-slate-500">Marcá los días y elegí rangos (cada 30 min). Podés sumar un segundo horario por día.</p>
            <div class="mt-2 space-y-2">${htmlBloqueDisponibilidadSemana(prof)}</div>
          </section>

          ${expServiciosFull ? `          <section class="rounded-2xl border border-slate-200/90 bg-white p-4 shadow-sm ring-1 ring-slate-100/80">
            <div class="mb-3 flex items-center gap-2 text-sm font-semibold text-slate-800">
              <span class="flex h-8 w-8 items-center justify-center rounded-full bg-amber-100 text-amber-700" aria-hidden="true">✦</span>
              Frase personal
            </div>
            <label class="block text-[10px] font-bold uppercase tracking-wide text-slate-500">Tu slogan</label>
            <input id="serv-mp-frase" type="text" class="mt-1 w-full rounded-xl border-0 bg-slate-50 py-3 px-3 text-sm ring-1 ring-slate-200 focus:outline-none focus:ring-2 focus:ring-brand-primary/35" placeholder="Ej: Soluciones rápidas con garantía…" maxlength="180" value="${esc(fraseVal)}" />
            <p class="mt-1.5 text-[11px] italic leading-snug text-slate-500">Esta frase puede mostrarse en tu tarjeta destacada en el barrio.</p>
          </section>` : ''}

          ${bloqueTarjetasMiPerfil}

          <button type="button" id="serv-mp-save" data-label="Guardar perfil" class="btn-async mlv-btn-primary flex w-full items-center justify-center gap-2 rounded-2xl bg-brand-primary py-4 text-sm font-bold text-white shadow-md transition hover:brightness-105">
            ${iconRocketMp()}
            Guardar mi perfil profesional
          </button>
          <p class="px-1 text-center text-[11px] leading-snug text-slate-500">Al guardar, aceptás los términos de convivencia de La Victoria Market.</p>
          <button type="button" id="serv-mp-lista" class="w-full rounded-xl border border-slate-200 bg-white py-3 text-sm font-semibold text-slate-700">Ver listado de profesionales</button>
        </main>
      </div>`);

    if (fotoMostrar) aplicarFondoFotoServMp(fotoMostrar);

    function syncSelectRubros() {
      const a = document.getElementById('serv-mp-r1')?.value || '';
      const b = document.getElementById('serv-mp-r2')?.value || '';
      const c = document.getElementById('serv-mp-r3')?.value || '';
      const s2 = document.getElementById('serv-mp-r2');
      const s3 = document.getElementById('serv-mp-r3');
      if (s2) s2.innerHTML = htmlOpcionesRubro({ selected: b, emptyLabel: 'Segunda especialidad (opcional)', excludeIds: [a] });
      if (s3) s3.innerHTML = htmlOpcionesRubro({ selected: c, emptyLabel: 'Tercera especialidad (opcional)', excludeIds: [a, b].filter(Boolean) });
    }

    document.getElementById('serv-mp-r1')?.addEventListener('change', syncSelectRubros);
    if (expServiciosFull) {
      document.getElementById('serv-mp-r2')?.addEventListener('change', syncSelectRubros);
    }
    wireDisponibilidadSemanaUi();

    document.getElementById('serv-mp-back')?.addEventListener('click', () => nav.goBack());
    document.getElementById('serv-mp-lista')?.addEventListener('click', () => nav.pushServiciosHome());

    async function validarPuedePublicarNuevaTarjeta() {
      const p = await serviciosRepository.obtenerProfesional(u.uid);
      if (!p || !Array.isArray(p.rubros) || p.rubros.length === 0) {
        window.alert('Primero guardá tu perfil con al menos una especialidad.');
        return false;
      }
      if ((Number(p.tarjetas_saldo) || 0) < 1) {
        const url = buildWhatsAppUrl(waTelCompraTarjetasSaldo(), WA_COMPRA_TARJETAS_MSJ);
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
        window.alert('No tenés tarjetas disponibles. Te abrimos WhatsApp para comprar más.');
        return false;
      }
      return true;
    }

    if (expServiciosFull) {
      aplicarSrcDataFireUrlImgsTarjetaFicha(document.getElementById('serv-mp-tarjetas-grid'));
      document.querySelectorAll('.serv-mp-slot-thumb').forEach((img) => {
        img.addEventListener(
          'error',
          () => {
            const plantilla = ASSET_SERV_TARJETA_PLANTILLA;
            let esPlantilla = false;
            try {
              const abs = new URL(plantilla, window.location.origin).href;
              esPlantilla = img.src === abs || img.src.endsWith(plantilla);
            } catch {
              esPlantilla = img.src.includes('tarjeta-trabajo-plantilla');
            }
            if (!esPlantilla) {
              img.src = plantilla;
              img.closest('.serv-mp-slot-filled')?.setAttribute('data-thumb', esc(plantilla));
            }
          },
          { once: true }
        );
      });
      document.querySelectorAll('.serv-mp-slot-empty').forEach((btn) => {
        btn.addEventListener('click', async () => {
          if (!(await validarPuedePublicarNuevaTarjeta())) return;
          const deck = document.getElementById('serv-mp-deck-icon');
          if (!prefersReducedMotionTarjeta()) {
            await runTarjetaDeckOpenTransition({
              deckEl: deck,
              targetEl: btn,
              skipPart1: false,
              imageUrl: ASSET_SERV_TARJETA_PLANTILLA,
            });
          }
          showPublicarTarjetaForm(u.uid);
        });
      });

      document.querySelectorAll('.serv-mp-slot-filled').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const tid = btn.getAttribute('data-tarjeta-id');
          const thumbRaw = btn.getAttribute('data-thumb') || '';
          let thumb = urlDesdeDataFireAttr(thumbRaw);
          if (!thumb) thumb = ASSET_SERV_TARJETA_PLANTILLA;
          const tDoc = tarjList.find((x) => x.id === tid);
          if (!tDoc) return;
          const deck = document.getElementById('serv-mp-deck-icon');
          if (!prefersReducedMotionTarjeta()) {
            await runTarjetaDeckOpenTransition({
              deckEl: deck,
              targetEl: btn,
              skipPart1: true,
              imageUrl: thumb,
            });
          }
          showTarjetaResumenProfesional(u.uid, tDoc);
        });
      });

      document.getElementById('serv-mp-comprar-wa')?.addEventListener('click', () => {
        const url = buildWhatsAppUrl(waTelCompraTarjetasSaldo(), WA_COMPRA_TARJETAS_MSJ);
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
      });
    }

    const fotoInput = document.getElementById('serv-mp-foto');
    fotoInput?.addEventListener('change', async (e) => {
      const file = e.target.files?.[0];
      e.target.value = '';
      if (!file) return;
      const hint = document.getElementById('serv-mp-foto-hint');
      if (hint) hint.textContent = 'Subiendo foto…';
      try {
        const url = await serviciosRepository.subirFotoPerfilServicios(u.uid, file);
        const hid = document.getElementById('serv-mp-foto-url');
        if (hid) hid.value = url;
        aplicarFondoFotoServMp(url);
        if (hint) hint.textContent = 'Foto lista. Recordá guardar el perfil.';
      } catch (err) {
        console.error(err);
        if (hint) hint.textContent = err?.message || 'No se pudo subir la foto.';
      }
    });

    document.getElementById('serv-mp-save')?.addEventListener('click', async () => {
      const msg = document.getElementById('serv-mp-msg');
      const btnSave = document.getElementById('serv-mp-save');
      const rA = document.getElementById('serv-mp-r1')?.value || '';
      const rB = expServiciosFull ? document.getElementById('serv-mp-r2')?.value || '' : '';
      const rC = expServiciosFull ? document.getElementById('serv-mp-r3')?.value || '' : '';
      const rubros = normalizarRubrosPerfil(expServiciosFull ? [rA, rB, rC] : [rA]);
      const disponibilidad_semana_estado = readDisponibilidadSemanaEstadoFromDom();
      const frase_personal = expServiciosFull
        ? document.getElementById('serv-mp-frase')?.value || ''
        : String(prof?.frase_personal || '');
      const nombre_publico = String(document.getElementById('serv-mp-nombre')?.value || '').trim() || nombreInicial;
      const v = validarPayloadMiPerfilServicios({
        rubros,
        disponibilidad_semana_estado,
        descripcion_publica: '',
        frase_personal,
      });
      if (!v.ok) {
        if (msg) {
          msg.classList.remove('text-emerald-700');
          msg.classList.add('text-red-700');
          msg.textContent = v.error;
        }
        return;
      }
      if (msg) msg.textContent = '';
      await withBusyButton(
        btnSave,
        async () => {
        try {
          await serviciosRepository.guardarMiPerfil(u.uid, {
            ...v.value,
            nombre_publico,
            telefono_whatsapp: tel,
            foto_perfil_servicios_url: document.getElementById('serv-mp-foto-url')?.value || '',
            perfil_publico: true,
          });
          if (msg) {
            msg.classList.remove('text-red-700');
            msg.classList.add('text-emerald-700');
            msg.textContent = 'Perfil guardado.';
          }
          const p2 = await serviciosRepository.obtenerProfesional(u.uid);
          const saldoEl = document.getElementById('serv-mp-saldo-inline');
          if (saldoEl && p2) saldoEl.textContent = String(Number(p2.tarjetas_saldo) || 0);
          await openMiniModalOk({
            title: 'Perfil profesional actualizado',
            message: 'Los cambios ya están publicados en Servicios del barrio.',
            okLabel: 'Ir a inicio',
          });
          nav.replaceServiciosHome?.();
        } catch (err) {
          console.error(err);
          if (msg) {
            msg.classList.add('text-red-700');
            msg.classList.remove('text-emerald-700');
            msg.textContent = err?.message || 'No se pudo guardar.';
          }
        }
        },
        { labelBusy: 'Guardando…' }
      );
    });
  }

  function showTarjetaResumenProfesional(uid, t) {
    void uid;
    const imgs = [...urlsHttpTarjeta(t.fotos_antes), ...urlsHttpTarjeta(t.fotos_despues)]
      .slice(0, 6)
      .map((url) => {
        const u = normalizarUrlImagenServicios(url);
        if (!/^https?:\/\//i.test(u) && !u.startsWith('//')) {
          return '<div class="h-24 w-24 rounded-xl bg-slate-100 ring-1 ring-slate-200/90" aria-hidden="true"></div>';
        }
        const enc = esc(u);
        return `<img alt="" class="serv-tr-gal-img h-24 w-24 rounded-xl object-cover ring-1 ring-slate-200/90" loading="lazy" decoding="async" src="${enc}" />`;
      })
      .join('');
    render(`
      <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
        <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
          <button type="button" id="serv-tr-back" class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Volver">${iconBack()}</button>
          <h1 class="flex-1 text-center font-heading text-lg font-bold text-brand-primary">Tu tarjeta</h1>
          <span class="w-10"></span>
        </header>
        <main class="mx-auto max-w-lg px-4 pt-4">
          <p class="font-heading text-lg font-bold text-slate-900">${esc(t.titulo_caso || 'Trabajo')}</p>
          <p class="mt-1 text-sm text-slate-600">${esc(t.cliente_display || '')} · ${esc(t.duracion_txt || '')}</p>
          <div class="mt-4 flex flex-wrap gap-2">${imgs || '<p class="text-sm text-slate-500">Sin fotos.</p>'}</div>
        </main>
      </div>`);
    aplicarSrcDataFireUrlImgsTarjetaFicha(document.querySelector('.min-h-screen'));
    document.getElementById('serv-tr-back')?.addEventListener('click', () => void showServiciosMiPerfil());
  }

  function showPublicarTarjetaForm(uid) {
    const hintTagBase = 'mt-1.5 min-h-[2.75rem] text-[11px] leading-snug';
    let tagVerificadoPara = '';

    render(`
      <div class="min-h-screen bg-brand-surface mlv-bg-surface pb-28">
        <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
          <button type="button" id="serv-tj-back" class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Volver">${iconBack()}</button>
          <h1 class="flex-1 text-center font-heading text-lg font-bold text-brand-primary">Nueva tarjeta</h1>
          <span class="w-10"></span>
        </header>
        <main class="mx-auto max-w-lg px-4 pt-4">
          <p id="serv-tj-msg" class="min-h-[1.25rem] text-sm text-red-700"></p>
          <label class="mt-2 block text-xs font-medium text-slate-600">Título del trabajo</label>
          <input id="serv-tj-titulo" class="mt-1 w-full rounded-xl border-0 bg-white p-3 text-sm ring-1 ring-slate-200" />
          <label class="mt-3 block text-xs font-medium text-slate-600">
            Tag del cliente
            <span class="block font-normal text-slate-500">El mismo ID que figura en el saludo inicial del WhatsApp de La Victoria (código corto o ID largo).</span>
          </label>
          <div class="mt-1 flex gap-2">
            <div class="relative min-w-0 flex-1">
              <input id="serv-tj-tag" autocomplete="off" placeholder="Ej. AB2C o pegá el ID largo" class="w-full rounded-xl border-0 bg-white py-3 pl-3 pr-10 text-sm ring-1 ring-slate-200" />
              <span id="serv-tj-tag-ok" class="pointer-events-none absolute right-3 top-1/2 hidden -translate-y-1/2 text-emerald-600" aria-hidden="true">
                <svg class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" /></svg>
              </span>
            </div>
            <button type="button" id="serv-tj-verify" data-label="Verificar" class="btn-async shrink-0 rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-semibold text-slate-800 shadow-sm hover:bg-slate-50">Verificar</button>
          </div>
          <p id="serv-tj-tag-hint" class="${hintTagBase} text-slate-400" aria-live="polite"></p>
          <input type="hidden" id="serv-tj-comprador-uid" value="" />
          <input type="hidden" id="serv-tj-cli-display" value="" />
          <label class="mt-3 block text-xs font-medium text-slate-600">Duración / tipo</label>
          <input id="serv-tj-dur" placeholder="Ej. 1 jornada" class="mt-1 w-full rounded-xl border-0 bg-white p-3 text-sm ring-1 ring-slate-200" />
          <p class="mt-4 text-xs font-semibold text-slate-600">2 fotos antes</p>
          <input id="serv-tj-a" type="file" accept="image/*" multiple class="mt-1 text-sm" />
          <p class="mt-3 text-xs font-semibold text-slate-600">2 fotos después</p>
          <input id="serv-tj-d" type="file" accept="image/*" multiple class="mt-1 text-sm" />
          <button type="button" id="serv-tj-pub" data-label="Publicar (consume 1 tarjeta)" class="btn-async mlv-btn-primary mt-6 w-full rounded-xl bg-brand-primary py-3.5 text-sm font-bold text-white shadow-md transition hover:brightness-105 disabled:pointer-events-none disabled:opacity-60">Publicar (consume 1 tarjeta)</button>
        </main>
      </div>`);

    function setEstadoVerificacionTag(estado) {
      const ok = document.getElementById('serv-tj-tag-ok');
      const hint = document.getElementById('serv-tj-tag-hint');
      const hidU = document.getElementById('serv-tj-comprador-uid');
      const hidL = document.getElementById('serv-tj-cli-display');
      if (estado === 'idle') {
        tagVerificadoPara = '';
        ok?.classList.add('hidden');
        if (hint) {
          hint.textContent = '';
          hint.className = `${hintTagBase} text-slate-400`;
        }
        if (hidU) hidU.value = '';
        if (hidL) hidL.value = '';
        return;
      }
      if (estado === 'loading') {
        ok?.classList.add('hidden');
        if (hint) {
          hint.textContent = 'Consultando…';
          hint.className = `${hintTagBase} text-slate-500`;
        }
        return;
      }
    }

    function limpiarSiTagCambio() {
      const inp = document.getElementById('serv-tj-tag');
      const cur = String(inp?.value || '').trim();
      if (tagVerificadoPara && cur !== tagVerificadoPara) setEstadoVerificacionTag('idle');
    }

    async function verificarTagCliente() {
      const msg = document.getElementById('serv-tj-msg');
      const hint = document.getElementById('serv-tj-tag-hint');
      const inp = document.getElementById('serv-tj-tag');
      const raw = String(inp?.value || '').trim();
      if (msg) msg.textContent = '';
      if (!raw) {
        if (hint) {
          hint.textContent = 'Ingresá el tag o ID del cliente.';
          hint.className = `${hintTagBase} text-amber-800`;
        }
        setEstadoVerificacionTag('idle');
        return;
      }
      setEstadoVerificacionTag('loading');
      try {
        const r = await serviciosRepository.resolverTagCompradorTarjeta(raw);
        if (r.uid === String(uid)) {
          setEstadoVerificacionTag('idle');
          if (hint) {
            hint.textContent = 'No podés usar tu propio tag.';
            hint.className = `${hintTagBase} text-red-700`;
          }
          return;
        }
        tagVerificadoPara = raw;
        const hidU = document.getElementById('serv-tj-comprador-uid');
        const hidL = document.getElementById('serv-tj-cli-display');
        if (hidU) hidU.value = r.uid;
        if (hidL) hidL.value = r.etiqueta_cliente;
        document.getElementById('serv-tj-tag-ok')?.classList.remove('hidden');
        if (hint) {
          hint.textContent = `Listo: ${r.etiqueta_cliente}`;
          hint.className = `${hintTagBase} text-emerald-800`;
        }
      } catch (e) {
        console.error(e);
        setEstadoVerificacionTag('idle');
        const m = e?.message || e?.details || 'No encontramos ese tag.';
        if (hint) {
          hint.textContent = m;
          hint.className = `${hintTagBase} text-red-700`;
        }
      }
    }

    document.getElementById('serv-tj-back')?.addEventListener('click', () => showServiciosMiPerfil());
    document.getElementById('serv-tj-verify')?.addEventListener('click', () => {
      const vbtn = document.getElementById('serv-tj-verify');
      void withBusyButton(vbtn, () => verificarTagCliente(), { labelBusy: 'Consultando…' });
    });
    document.getElementById('serv-tj-tag')?.addEventListener('input', limpiarSiTagCambio);
    document.getElementById('serv-tj-pub')?.addEventListener('click', async () => {
      const msg = document.getElementById('serv-tj-msg');
      const pubBtn = document.getElementById('serv-tj-pub');
      const titulo_caso = document.getElementById('serv-tj-titulo')?.value || '';
      const duracion_txt = document.getElementById('serv-tj-dur')?.value || '';
      const comprador_uid = document.getElementById('serv-tj-comprador-uid')?.value || '';
      const cliente_display = document.getElementById('serv-tj-cli-display')?.value || '';
      const tagInput = String(document.getElementById('serv-tj-tag')?.value || '').trim();
      const inA = document.getElementById('serv-tj-a');
      const inD = document.getElementById('serv-tj-d');
      const fa = Array.from(inA?.files || []).slice(0, 2);
      const fd = Array.from(inD?.files || []).slice(0, 2);
      const files = [...fa, ...fd];
      if (msg) msg.textContent = '';
      if (!comprador_uid || !cliente_display || tagInput !== tagVerificadoPara) {
        if (msg) msg.textContent = 'Verificá el tag del cliente con el botón Verificar.';
        return;
      }
      await withBusyButton(pubBtn, async () => {
        try {
          await serviciosRepository.publicarTarjetaDesdeFormulario(
            uid,
            {
              titulo_caso,
              cliente_display,
              comprador_uid,
              duracion_txt,
            },
            files
          );
          await showServiciosMiPerfil();
        } catch (e) {
          console.error(e);
          if (msg) msg.textContent = e?.message || 'Error al publicar.';
        }
      }, { labelBusy: 'Publicando…' });
    });
  }

  async function showServiciosFicha(uidProf) {
    const nav = getNavigation();
    const u = getFirebase().auth.currentUser;
    if (!u) {
      nav.pushLoginShow();
      return;
    }
    const uid = String(uidProf || '').trim();
    let p = null;
    let tarjetas = [];
    try {
      p = await serviciosRepository.obtenerProfesional(uid);
      const r = await serviciosRepository.listarTarjetasVisibles(uid, { pageSize: 3 });
      tarjetas = r.docs;
    } catch (e) {
      console.error(e);
    }
    if (!p || !p.rubros?.length) {
      render(`
        <div class="min-h-screen bg-brand-surface mlv-bg-surface px-4 py-8">
          <p class="text-sm text-slate-600">Perfil no disponible.</p>
          <button type="button" id="serv-f-back" class="mt-4 rounded-xl bg-brand-primary px-4 py-2 text-sm text-white">Volver</button>
        </div>`);
      document.getElementById('serv-f-back')?.addEventListener('click', () => nav.goBack());
      return;
    }

    const rs = (p.rubros || []).map((id) => labelRubroServicio(id)).join(' · ');
    const prem =
      (Number(p.tarjetas_saldo) || 0) > 0 || p.servicios_premium === true || tarjetas.length > 0;
    const val = p.perfil_validado === true;

    const nombrePub = String(p.nombre_publico || 'Profesional').trim();
    const inicialesFicha = initialsFromNameEmail(nombrePub, '');
    const fotoFicha = urlFotoPerfilLista(p.foto_perfil_servicios_url);
    const avatarFicha = fotoFicha
      ? `<div class="serv-pro-avatar-wrap relative h-[4.25rem] w-[4.25rem] shrink-0 overflow-hidden rounded-full bg-gradient-to-br from-brand-primary/20 via-white to-brand-primary/10 text-base font-bold text-brand-primary ring-2 ring-white shadow-md" data-initials="${esc(inicialesFicha)}"><img alt="" class="serv-pro-avatar-img absolute inset-0 z-0 h-full w-full max-w-none object-cover" decoding="async" src="${esc(fotoFicha)}" /></div>`
      : `<div class="serv-pro-avatar-wrap relative flex h-[4.25rem] w-[4.25rem] shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-brand-primary/20 via-white to-brand-primary/10 text-lg font-bold text-brand-primary ring-2 ring-white shadow-md" data-initials="${esc(inicialesFicha)}"><span class="absolute inset-0 z-0 flex items-center justify-center" aria-hidden="true">${esc(inicialesFicha)}</span></div>`;

    const bloquesTarjetas = tarjetas
      .map((t) => {
        const sub = `${esc(t.cliente_display || '')}${
          t.duracion_txt ? ` · ${esc(String(t.duracion_txt))}` : ''
        }`;
        return `<article class="rounded-2xl border border-slate-200/90 bg-white p-4 shadow-sm ring-1 ring-slate-100/80">
          <p class="font-semibold text-slate-900">${esc(t.titulo_caso || '')}</p>
          <p class="text-xs text-slate-500">${sub}</p>
          ${htmlFichaTarjetaAntesDespues(t)}
          ${htmlFichaTarjetaValoracion(t)}
        </article>`;
      })
      .join('');

    render(`
      <div id="serv-ficha-pro-root" class="min-h-screen bg-slate-100/90 mlv-bg-surface pb-28">
        <header class="sticky top-0 z-20 flex items-center gap-3 border-b border-slate-200/80 bg-brand-surface/95 px-4 py-3 backdrop-blur-sm">
          <button type="button" id="serv-f-back" class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full hover:bg-slate-200/50" aria-label="Volver">${iconBack()}</button>
          <h1 class="flex-1 text-center font-heading text-lg font-bold text-brand-primary">Profesional</h1>
          <span class="w-10"></span>
        </header>
        <main class="mx-auto max-w-lg px-4 pt-4">
          <div class="flex gap-3">
            ${avatarFicha}
            <div class="min-w-0 flex-1">
          <p class="font-heading text-xl font-bold text-slate-900">${esc(p.nombre_publico || '')}</p>
          <p class="mt-1 text-sm font-medium text-brand-primary">${esc(rs)}</p>
          ${prem || val ? `<p class="mt-2 text-xs font-semibold text-amber-800">${prem ? 'Destacado en servicios' : ''}${prem && val ? ' · ' : ''}${val ? 'Profesional verificado' : ''}</p>` : ''}
          ${p.ubicacion_barrio ? `<p class="mt-1 text-sm text-slate-600">${esc(p.ubicacion_barrio)}</p>` : ''}
          <p class="mt-3 text-sm text-slate-700">${esc(textoDisponibilidadParaPublico(p) || '')}</p>
          ${p.descripcion_publica ? `<p class="mt-2 text-sm text-slate-600">${esc(p.descripcion_publica)}</p>` : ''}
            </div>
          </div>
          <button type="button" id="serv-f-wa" class="mt-5 flex w-full items-center justify-center gap-2 rounded-full bg-brand-secondary py-3.5 text-sm font-bold text-white shadow-lg transition hover:bg-brand-secondary/90">${mlvPng('whatsapp', 'h-6 w-6 shrink-0 object-contain brightness-0 invert', { w: 24, h: 24 })}Contactar por WhatsApp</button>
          <h2 class="mt-8 font-heading text-sm font-bold uppercase tracking-wide text-slate-500">Últimos trabajos</h2>
          <div id="serv-ficha-trabajos" class="mt-3 space-y-4">${bloquesTarjetas || '<p class="text-sm text-slate-500">Aún no hay tarjetas publicadas.</p>'}</div>
        </main>
      </div>`);

    document.getElementById('serv-f-back')?.addEventListener('click', () => nav.goBack());
    document.getElementById('serv-f-wa')?.addEventListener('click', () => {
      modalDisclaimerAntesWhatsapp(() =>
        abrirWhatsappProfesional({
          telefono: p.telefono_whatsapp,
          nombre: p.nombre_publico,
        })
      );
    });
    const fichaRoot = document.getElementById('serv-ficha-pro-root');
    aplicarSrcDataFireUrlImgsTarjetaFicha(fichaRoot);
    fichaRoot?.querySelectorAll('.serv-pro-avatar-img').forEach((img) => {
      const wrap = img.closest('.serv-pro-avatar-wrap');
      const initials = wrap?.getAttribute('data-initials') || '?';
      img.addEventListener(
        'error',
        () => {
          if (!wrap || wrap.getAttribute('data-avatar-fallback') === '1') return;
          wrap.setAttribute('data-avatar-fallback', '1');
          img.remove();
          const sp = document.createElement('span');
          sp.className =
            'absolute inset-0 z-0 flex items-center justify-center text-base font-bold text-brand-primary';
          sp.setAttribute('aria-hidden', 'true');
          sp.textContent = initials;
          wrap.appendChild(sp);
        },
        { once: true }
      );
    });
  }

  return {
    showServiciosHome,
    showServiciosMiPerfil,
    showServiciosFicha,
  };
}
